//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ChooseOrderGroup',
    props: {
        group: {
            required: true,
            type: String,
        },
    },
    data: () => {
        return {
            orderGroups: {
                one: 'one',
                two: 'two',
                three: 'three',
            },
        };
    },
    computed: {
        groupOptions: {
            get: function () {
                return this.group;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/template-school/choose-plan-school/ChooseOrderGroup.vue